export const createBorder = (
  side: 'Left' | 'Top' | 'Right' | 'Bottom',
  color: string,
) => ({
  [`border${side}Color`]: color,
  [`border${side}Width`]: '1',
  [`border${side}Style`]: 'solid',
});
